import { Injectable } from '@angular/core';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Auth0User } from '../../interface/auth0-user';

@Injectable({
  providedIn: 'root',
})
export class LocalAuthService {
  constructor(private auth0: Auth0Service) {}

  get user$(): Observable<Auth0User> {
    return this.auth0.user$ as Observable<Auth0User>;
  }

  get firstName$(): Observable<string> {
    return this.user$.pipe(
      map((user) => user?.['https://onlyusedtesla.com/firstName'] || '')
    );
  }
}
